<div mat-dialog-content>
  <app-dropdown-tree
    [data]="mappings"
    [datum]="mapping"
    [groupByField]="'model_name'"
    [textField]="['scenario_name', 'return_period']"
    [valueField]="'id'"
    [placeholder]="'Selected Scenario'"
    [sort]="sortModelScenarioMapping"
    (select)="onSelectedChange($event)"
  ></app-dropdown-tree>
</div>
<div mat-dialog-actions align="end">
  <button appButton border mat-dialog-close>Close</button>
  <button appButton border accent [disabled]="!mapping" (click)="onApplyClick()">Apply</button>
</div>
